import { useTranslation } from "react-i18next";
import { Car } from "../../types/car.types";
import { useNavigate } from "react-router-dom";
import { Trash2 } from "lucide-react";

interface CarsListProps {
  cars: Car[];
  setSelectedCar: (car: Car) => void;
  setShowEditCard: (show: boolean) => void;
  setShowDeleteCard: (show: boolean) => void;
}

export const CarsList = ({
  cars,
  setSelectedCar,
  setShowEditCard,
  setShowDeleteCard,
}: CarsListProps) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  return (
    <>
      <h2 className="text-lg font-semibold mb-4">{t("My Cars")}</h2>

      <div className="flex flex-col gap-3">
        {cars.map((car) => (
          <div
            key={car._id}
            className="flex items-center justify-between bg-primaryBg dark:bg-primaryBgDark p-4 rounded-lg hover:bg-primaryBg/80 hover:dark:bg-primaryBgDark/80 cursor-pointer"
            onClick={() => navigate(`/dashboard?carId=${car._id}`)}
          >
            <div>
              <p className="font-semibold text-sm">
                {car.brand} {car.model}
              </p>
              <p className="text-xs opacity-70">{car.number}</p>
            </div>

            <div className="flex gap-3">
              <button
                className="px-2 py-1 text-xs bg-secondaryText/80 dark:bg-secondaryTextDark text-primaryText rounded hover:bg-secondaryText hover:dark:bg-secondaryTextDark/80"
                onClick={(e) => {
                  e.stopPropagation();
                  setSelectedCar(car);
                  setShowEditCard(true);
                }}
              >
                {t("Edit")}
              </button>

              <button
                className="px-2 py-1 rounded flex items-center justify-center hover:bg-red-500/10"
                onClick={(e) => {
                  e.stopPropagation();
                  setSelectedCar(car);
                  setShowDeleteCard(true);
                }}
              >
                <Trash2 size={16} />
              </button>
            </div>
          </div>
        ))}
      </div>
    </>
  );
};
